<template>
  <div class="orgEffectPage" id="orgEffect">
    <div class="subordinateEcharts">
      <p>{{subordinateTitle}}</p>
      <ve-histogram
        height="350px"
        :data="subordinateData"
        :extend="downChartExtend"
        class="subCharts"
        v-if="!this.showSubordinateAssess"
      ></ve-histogram>
      <div class="nonePage" v-if="this.showSubordinateAssess">
        <img :src="nonePng" alt />
        <p>暂无数据</p>
      </div>
    </div>
    <div class="itselfEcharts">
      <p>{{itselfTitle}}</p>
      <ve-histogram
        height="350px"
        :data="itselfData"
        :extend="itselfChartExtend"
        class="itselfCharts"
        v-if="!this.showItselfAssess"
      ></ve-histogram>
      <div class="nonePage" v-if="this.showItselfAssess">
        <img :src="nonePng" alt />
        <p>暂无数据</p>
      </div>
    </div>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import nonePng from "@/assets/none.png";
const refreshPage = () => import("@/components/common/refreshPage");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "userEffect",
  data() {
    return {
      nonePng: nonePng, //默认图片
      subordinateTitle: "政区成效",
      itselfTitle: "责任区成效",
      showSubordinateAssess: false,
      showItselfAssess: false,
      downChartExtend: {
        legend: {
          show: false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          axisLabel: {
            show: true,
            interval: 8,
            rotate: -60,
            margin: 5,
            textStyle: {
              color: "#666",
              fontSize: 10
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ebedf0"
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed"
              }
            }
          },
          grid: {
            //    x: 40,
            x2: 10, //图与右侧的边距
            y2: 80 //图与下边的边距
          }
        },
        yAxis: {
          axisLabel: {
            textStyle: {
              color: "#999",
              fontSize: 14
            }
          },

          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed"
            }
          }
        },
      
      },
      subordinateData: {
        columns: [],
        rows: []
      },
      itselfData: {
        columns: [],
        rows: []
      },
      itselfChartExtend: {
        legend: {
          show: false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          axisLabel: {
            interval: 8,
            rotate: -60,
            margin: 5,
            textStyle: {
              color: "#666",
              fontSize: 12
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ebedf0"
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed"
              }
            }
          }
        },
        yAxis: {
          axisLabel: {
            textStyle: {
              color: "#999",
              fontSize: 14
            }
          },

          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed"
            }
          }
        },
        
      },
      refreshPage: false, //网络失败
      clientType: "" //手机类型
    };
  },
  components: {},
  mounted() {
    let winHeight = document.documentElement.clientHeight; //视口大小
    this.clientType = getDeviceType();
    document.getElementById("orgEffect").style.height = winHeight - 45 + "px";
    this.initPage();
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.linLong.record
        .getGroupEffect()
        .then(res => {
          if (res.code == "1") {
            // this.subordinateData.columns = ["政区", "得分"];
            // this.itselfData.columns = ["责任区", "得分"];

            // this.setSubordinateDataRows(res.data.regionEffectList);
            // this.setItselfDataRows(res.data.areaEffectList)

            if (res.data.regionEffectList != null) {
              this.showSubordinateAssess = false;
              this.subordinateData.columns = ["政区", "得分"];
              this.setSubordinateDataRows(res.data.regionEffectList);
            } else {
              this.subordinateData = [];
              this.showSubordinateAssess = true;
            }
            if (res.data.areaEffectList != null) {
              this.showItselfAssess = false;
              this.itselfData.columns = ["责任区", "得分"];
              this.setItselfDataRows(res.data.areaEffectList);
            } else {
              this.showItselfAssess = true;
              this.itselfData = [];
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
          _this.refreshPage = true;
        });
    },
    setSubordinateDataRows(data) {
      let _this = this;
      let NewObject = {};
      for (let i = 0; i < data.length; i++) {
        NewObject = {
          政区: data[i].zqName,
          得分: data[i].score
        };
        _this.subordinateData.rows.push(NewObject);
      }
    },
    setItselfDataRows(data) {
      let _this = this;
      let NewObject = {};
      for (let i = 0; i < data.length; i++) {
        NewObject = {
          责任区: data[i].areaName,
          得分: data[i].score
        };
        _this.itselfData.rows.push(NewObject);
      }
    }
  }
};
</script>
<style lang="less" scope>
.orgEffectPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-y: scroll;
  .nonePage {
    width: 120px;
    height: 180px;
    margin: 10px auto;
    padding-bottom: 30px;
    img {
      display: block;
      max-width: 100px;
        max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
      
    }
  }
  .subordinateEcharts {
    background-color: #fff;
    padding: 10px 16px 0 16px;

    p {
      font-size: 14px;
      color: #666;
    }

    .subCharts {
      height: 350px;
    }
  }

  .itselfEcharts {
    margin-top: 10px;
    padding: 10px 16px 0 16px;
    background-color: #fff;

    p {
      font-size: 14px;
      color: #666;
    }

    .itselfCharts {
      height: 350px;
    }
  }
}
</style>